module.exports = __webpack_public_path__ + "img/01-xxl.64ebc4b.webp";